"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPortal = require("react-portal");

var _Modal = require("./Modal.styles");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Modal = (0, _react.forwardRef)(function (_ref, ref) {
  var size = _ref.size,
      padding = _ref.padding,
      visible = _ref.visible,
      children = _ref.children,
      topOffset = _ref.topOffset,
      keepMounted = _ref.keepMounted,
      styles = _ref.styles,
      overlay = _ref.overlay;
  (0, _react.useEffect)(function () {
    var element = document.getElementById('root');

    if (visible) {
      element.setAttribute('style', 'overflow: hidden;');
    }

    return function () {
      element.removeAttribute('style');
    };
  }, [visible]);
  var wrapperStyle = (0, _react.useMemo)(function () {
    if (keepMounted) {
      return {
        display: visible ? 'block' : 'none'
      };
    }

    return {};
  }, [keepMounted, visible]);
  var innerWrapperStyle = (0, _react.useMemo)(function () {
    return {
      top: topOffset || '50%',
      maxWidth: _Modal.sizes[size],
      transform: "translate(-50%, ".concat(topOffset ? '0' : '-50%', ")"),
      marginBottom: topOffset
    };
  }, [topOffset, size]);
  var contentStyle = (0, _react.useMemo)(function () {
    return {
      padding: padding || '25px'
    };
  }, [padding]);
  var computeStyles = (0, _react.useMemo)(function () {
    var resultStyles = {
      wrapper: _objectSpread(_objectSpread({}, wrapperStyle), styles.wrapper || {}),
      innerWrapper: _objectSpread(_objectSpread({}, innerWrapperStyle), styles.innerWrapper || {}),
      content: _objectSpread(_objectSpread({}, contentStyle), styles.content || {}),
      inner: _objectSpread({}, styles.inner || {}),
      overlay: styles.overlay
    };
    return resultStyles;
  }, [styles, overlay, keepMounted, visible]);
  if (!keepMounted && !visible) return null;
  return (0, _core.jsx)(_reactPortal.Portal, null, (0, _core.jsx)("div", {
    css: _Modal.wrapperCss,
    style: computeStyles.wrapper
  }, (0, _core.jsx)(_Modal.Overlay, {
    background: overlay,
    style: computeStyles.overlay
  }, (0, _core.jsx)("div", {
    css: _Modal.innerCss,
    style: computeStyles.inner
  }, (0, _core.jsx)("div", {
    css: _Modal.innerWrapperCss,
    style: computeStyles.innerWrapper
  }, (0, _core.jsx)("div", {
    ref: ref,
    css: _Modal.contentCss,
    style: computeStyles.content
  }, children))))));
});
Modal.defaultProps = {
  visible: false,
  keepMounted: false,
  size: 'small',
  topOffset: undefined,
  padding: undefined,
  styles: {},
  overlay: true
};
Modal.propTypes = {
  children: _propTypes["default"].element.isRequired,
  keepMounted: _propTypes["default"].bool,
  padding: _propTypes["default"].string,

  /** Sets modal size, available sizes:
   * small: 375px,
   * medium: 535px,
   * mediumPlus: 620px,
   * large: 700px
   */
  size: _propTypes["default"].string,
  topOffset: _propTypes["default"].string,
  visible: _propTypes["default"].bool,
  styles: _propTypes["default"].shape({
    overlay: _propTypes["default"].object,
    content: _propTypes["default"].object,
    wrapper: _propTypes["default"].object,
    inner: _propTypes["default"].object,
    innerWrapper: _propTypes["default"].object
  }),
  overlay: _propTypes["default"].bool
};
var _default = Modal;
exports["default"] = _default;

//# sourceMappingURL=Modal.js.map